import { render, staticRenderFns } from "./activity-read-only-questions.vue?vue&type=template&id=1c4aee6b&scoped=true&"
import script from "./activity-read-only-questions.vue?vue&type=script&lang=js&"
export * from "./activity-read-only-questions.vue?vue&type=script&lang=js&"
import style0 from "./activity-read-only-questions.vue?vue&type=style&index=0&id=1c4aee6b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4aee6b",
  null
  
)

component.options.__file = "activity-read-only-questions.vue"
export default component.exports